/*
 |--------------------------------------------------------------------------
 | Modal
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 NO IMPORTS
\* ========================================================================== */

/* ========================================================================== *\
 CONSTANTS
\* ========================================================================== */

const /**
   * The module name
   * @type {String}
   */
  moduleName = "modal",
  /**
   * Lookup table with class names
   * @type {Object}
   */
  classNames = {
    modal: `js-${moduleName}`,
    dialog: `${moduleName}__content`,
    btnOpen: `${moduleName}__btn--open`,
    btnClose: `${moduleName}__btn--close`,
  },
  /**
   * Lookup table for selectors
   * @type {Object}
   */
  selectors = {
    modal: `.${classNames.modal}`,
    dialog: `.${classNames.dialog}`,
    btnOpen: `.${classNames.btnOpen}`,
    btnClose: `.${classNames.btnClose}`
  };

/* ========================================================================== *\
 SETUP MODAL
\* ========================================================================== */

class Modal {
  constructor(element) {
    this.element = element;
  }

  openModal(event) {
    // Don't open when:
    // - showOnce
    // - hit > 0
    // - not triggered by an event
    if (this.showOnce && this.hit > 0 && !(event instanceof PointerEvent)) {
      return;
    }

    this.element.removeAttribute("hidden");
    this.hit++;
    window.sessionStorage.setItem(this.storageKey, this.hit);
  };

  closeModal() {
    this.element.setAttribute("hidden", "hidden");
  };

  init() {
    this.storageKey = `${moduleName}-${this.element.id}-hit`;
    this.hit = window.sessionStorage.getItem(this.storageKey) || 0;

    this.dialog = this.element.querySelector(selectors.dialog);
    this.buttonsOpen = document.querySelectorAll(selectors.btnOpen);
    this.buttonsClose = this.element.querySelectorAll(selectors.btnClose);

    this.showOnce = 'showOnce' in this.element.dataset && this.element.dataset.showOnce !== 'false';
    this.showOnload = 'showOnload' in this.element.dataset && this.element.dataset.showOnload !== 'false';

    console.log({
      showOnce: this.showOnce,
      showOnload: this.showOnload
    })

    this.buttonsOpen.forEach(button => {
      button.addEventListener("click", this.openModal.bind(this));
    });

    this.buttonsClose.forEach(button => {
      button.addEventListener("click", this.closeModal.bind(this));
    });

    this.element.addEventListener("mouseup", ($event) => {
      if (this.dialog.contains($event.target)) {
        return;
      }

      this.closeModal();
    });

    if (this.showOnload) {
      this.openModal();
    }
  }
}

const modal = new Modal(selectors.container);
/* ========================================================================== *\
 END MODAL
\* ========================================================================== */

/* ========================================================================== *\
 NO EVENT HANDLING
 \* ========================================================================== */

/* ========================================================================== *\
INITIALIZATION
 \* ========================================================================== */

document.querySelectorAll(selectors.modal).forEach((element) => {
  const modal = new Modal(element);
  modal.init();
})

/* ========================================================================== *\
 NO EXPORTS
 \* ========================================================================== */
